module.exports = __webpack_public_path__ + "img/palmar-room-9.4cef33da.jpg";